import React, { useEffect, useState } from 'react';
import { _, Grid } from "gridjs-react";
import { Badge } from "reactstrap";
import moment from 'moment';
import '../../../assets/scss/BookingTabMonth.css';

// import {GestAppointment, Params} from "custom";
import {useHistory} from "react-router-dom";
import {GestAppointment, Params, Utils} from "custom";


const BookingTabDay = ({ selectedDay, appointments, getAppointments }) => {
    const [bookingsFiltered, setBookingsFiltered] = useState([]);
    const [showPastBookings, setShowPastBookings] = useState(false);
    const [showPastButton, setShowPastButton] = useState(false);

    const history = useHistory()

    useEffect(() => {
        console.log("selectedDay", selectedDay)
        filterBookings();
    }, [selectedDay, appointments, showPastBookings]);

    useEffect(() => {
        return () => {
            Params.removeHandlePaginator()
        };
    }, [])

    const filterBookings = () => {
        if (!selectedDay) return;

        const now = moment();
        const selectedMoment = moment(selectedDay, "YYYY-MM-DD");

        let filteredBookings = appointments.filter(appointment =>
            moment(appointment.date_hour).isSame(selectedMoment, 'day')
        );

        // if (selectedMoment.isSame(now, 'day')) {
        //     const hasPastBookings = filteredBookings.some(appointment =>
        //         moment(appointment.date_hour).isBefore(now)
        //     );
        //
        //     setShowPastButton(hasPastBookings);
        //     if (!showPastBookings) {
        //         filteredBookings = filteredBookings.filter(appointment =>
        //             moment(appointment.date_hour).isAfter(now)
        //         );
        //     }
        // } else {
        //     setShowPastButton(false);
        // }
        console.log("filteredBookings", filteredBookings)
        setBookingsFiltered(filteredBookings);
        setTimeout(() => {
            Params.addHandlePaginator()
        }, 1000)
    };

    const handleShowPastBookings = () => {
        setShowPastBookings(!showPastBookings);
    };

    const getStatusLabel = (appointment) => {
        switch (appointment.status) {
            case null:
                return <GestAppointment appointment={appointment} onResolve={getAppointments}/>;
            case "CANCELED":
                return <div className="custom-badge status-unreply">Annullato</div>;
            case "CONFIRMED":
                return <div className="custom-badge status-converted">Completato</div>;
            default:
                return null;
        }
    }

    if (!selectedDay) {
        return (
            <React.Fragment>
                <p>Seleziona un giorno per vedere gli appuntamenti.</p>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            {bookingsFiltered.length !== appointments.length && (
                <h6 className="text-center text-primary cursor-pointer" hidden={!(showPastButton)} onClick={handleShowPastBookings}>
                    <b>{showPastBookings ? 'Nascondi prenotazioni passate' : 'Visualizza prenotazioni passate'}</b>
                </h6>
            )}
            <Grid
                data={bookingsFiltered}
                columns={[
                    {
                        id: 'id',
                        hidden: true
                    },
                    {
                        id: 'id_lead',
                        hidden: true
                    },
                    {
                        id: 'date_hour',
                        width: "60px",
                        name: 'Ora',
                        formatter: (cell, row) => _(<span className="text-nowrap">
                            <a href="javascript:void(0)" onClick={() => history.push("/lead/detail/" + row.cells[1].data)}>
                                <h5 className="cursor-pointer"><i className="mdi mdi-calendar-clock" />&nbsp;&nbsp;{moment(cell).format("HH:mm")}</h5>
                            </a>
                        </span>)
                    },
                    {
                        id: 'name',
                        name: 'Nome',
                        formatter: (cell, row) => _(<span className="mb-5 text-left">
                            <a href="javascript:void(0)" onClick={() => history.push("/lead/detail/" + row.cells[1].data)}>
                                <h5 className="text-primary cursor-pointer"><b>{Utils.leadName(cell)}</b></h5>
                            </a>
                        </span>)
                    },
                    {
                        id: 'status',
                        name: 'Stato',
                        formatter: (cell, row) => _(<div className="text-center">
                            {getStatusLabel(bookingsFiltered.find((c) => c.id === row.cells[0].data))}
                        </div>)
                    },
                    {
                        id: 'consulent',
                        name: 'Consulente',
                        formatter: (cell, row) => _(<span className="mb-5 text-left">
                            <b>{cell?.firstname} {cell?.lastname}</b>
                        </span>)
                    }
                ]}
                style={{ table: { 'white-space': 'nowrap' } }}
                resizable={true}
                search={true}
                sort={true}
                pagination={{ enabled: true, limit: 25, page: Params.getActualPage() }}
                language={{
                    'search': {
                        'placeholder': '🔍 Cerca...'
                    },
                    'pagination': {
                        'previous': 'Indietro',
                        'next': 'Avanti',
                        'showing': 'Stai visualizzando da',
                        'results': 'appuntamenti',
                        'to': 'a',
                        'of': 'di',
                    },
                    'noRecordsFound': 'Nessun appuntamento trovato',
                    'error': 'Si è verificato un errore non previsto',
                }}
            />
        </React.Fragment>
    );
}

export default BookingTabDay;
